import { Box, ButtonBase, Stack, Typography } from "@mui/material";
import AppModal from "../../layouts/layout-mobile/AppModal";
import { useCallback, useState } from "react";
import FlexBetween from "../../components/flexbox/FlexBetween";
import { fCurrency } from "../../utils/format";
import toast from "react-hot-toast";
import useAxios from "../../hooks/useAxios";
import { useTonAddress, useTonConnectModal, useTonConnectUI, useTonWallet } from "@tonconnect/ui-react";
import { useTelegram } from "contexts/TelegramContext";
import useUserData from "../../hooks/useUserData";
import { beginCell } from "@ton/core";
import Decimal from "decimal.js";
import $ from 'jquery'
import { openInvoice } from "@telegram-apps/sdk-react"
import { useQueryClient } from "@tanstack/react-query";

export default function Increase({ children }) {
    const [open, setOpen] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const { callApi } = useAxios()
    const { open: openWallet } = useTonConnectModal()
    const { user } = useTelegram();
    const [tonConnectUI] = useTonConnectUI();
    const { userData } = useUserData()
    const wallet = useTonWallet();

    const { open: openConnectWallet } = useTonConnectModal()

    const walletAddress = useTonAddress(true);

    const app = window.Telegram?.WebApp;
    const queryClient = useQueryClient()

    const handleSendStar = useCallback(async () => {
        try {

            const link = await callApi(
                'get', `/payment/invoice-link-power`
            )
            const status = await openInvoice(link?.replace("https://t.me/$",""));
            if (status === "paid") {

                toast.success(
                    "Your mode will upgrade soon.",
                    {
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    },
                );
                setTimeout(() => {
                    queryClient.invalidateQueries(['UserData'])
                    toast.success('Your power is increased!', {
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                    })
                  }, 4000);
                
            }  
        } catch (error) {
            if (error.response && error.response.status === 400) {
                toast.error(`Error: ${error.response.data.message}`, {
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                toast.error("You rejected the transaction confirmation.", {
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }, [callApi, app])


    const handleSendTon = useCallback(async () => {
        setIsLoading(true);
        try {
            if (!user?.id && !userData?.user?.id) {
                setIsLoading(false);
                toast.error("An unexpected error occurred. Please restart mini app", {
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return
            }
            const body = beginCell()
                .storeUint(0, 32) // write 32 zero bits to indicate that a text comment will follow
                .storeStringTail(`INCREASE-POWER,${user?.id.toString() ?? userData?.user?.id}`) // write our text comment
                .endCell();
            const defaultTx = {
                // The transaction is valid for 10 minutes from now, in unix epoch seconds.
                validUntil: Math.floor(Date.now() / 1000) + 600,
                messages: [
                    {
                        // The receiver's address.
                        address: "UQCJxIp_w38mhclhwCtSvurxLyoWpGQg7g8SPKc8qk2qMvSF",
                        // Amount to send in nanoTON. For example, 0.005 TON is 5000000 nanoTON.
                        amount: new Decimal(1.2).mul(Decimal.pow(10, 9)).toString(),
                        payload: body.toBoc().toString("base64"),
                    },
                ],
            };
            await tonConnectUI.sendTransaction(defaultTx, {
                notifications: "success",
            });
            toast.success(
                "Your power will increase soon.",
                {
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                },
            );
            $('#INCREASE_POWER').addClass('active')
            setOpen(false)
        } catch (error) {
            if (error.response && error.response.status === 400) {
                toast.error(`Error: ${error.response.data.message}`, {
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                toast.error("You rejected the transaction confirmation.", {
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } finally {
            setIsLoading(false);
        }
    }, [userData?.user?.id, user?.id, tonConnectUI]);

    const handleOpen = useCallback((id, amount) => {
        if (!wallet?.account) {
            openConnectWallet()
        } else {
            handleSendTon(id, amount);
        }
    }, [handleSendTon, openConnectWallet, wallet?.account])


    return (
        <>
            <ButtonBase onClick={() => setOpen(true)}>{children}</ButtonBase>
            <AppModal title={'<Increase power capacity>'} open={open} onClose={() => setOpen(false)}>
                <Stack spacing={1}>
                    <FlexBetween gap={2} py={2}>
                        <Typography sx={{ color: '#8AEB5D' }}>[Power Capacity]</Typography>
                        <Typography>+{fCurrency(3000)}</Typography>
                        <Box flexGrow={1} />
                    </FlexBetween>
                    <ButtonBase onClick={handleSendStar} sx={{ width: '100%', height: '40px', background: "#89EC5D", color: '#000' }}><Typography variant="h6" fontWeight={500}>Pay_500_stars</Typography></ButtonBase>
                    <ButtonBase onClick={handleOpen} sx={{ width: '100%', height: '40px', background: "#fff", color: '#000' }}><Typography variant="h6" fontWeight={500}>Pay_1.2_TON</Typography></ButtonBase>
                    <Typography pt={1}><span style={{ color: '#FCBC05' }}>Note</span> Increase your power capacity with some stars & Restore your power!</Typography>
                </Stack>
            </AppModal>
        </>
    );
}